import { render, staticRenderFns } from "./PlatFormBackBar.vue?vue&type=template&id=b1f5fe5e&scoped=true&"
import script from "./PlatFormBackBar.vue?vue&type=script&lang=js&"
export * from "./PlatFormBackBar.vue?vue&type=script&lang=js&"
import style0 from "./PlatFormBackBar.vue?vue&type=style&index=0&id=b1f5fe5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f5fe5e",
  null
  
)

export default component.exports